// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { SectorsStayComponent } from './sectors-stay.component';
import { SectorStayDetailsModule } from './sector-stay-details/sector-stay-details.module';
import { StaySummaryModule } from './stay-summary/stay-summary.module';
import { SectorStayServicesModule } from './sector-stay-services/sector-stay-services.module';

@NgModule({
    declarations: [
        SectorsStayComponent,
    ],
    imports: [
        CommonModule,
        StaySummaryModule,
        SectorStayDetailsModule,
        SectorStayServicesModule,
    ],
    exports: [
        SectorsStayComponent,
    ],
})
export class SectorsStayModule {}